import { render, staticRenderFns } from "./subjectiveMark.vue?vue&type=template&id=47f18aed&scoped=true&"
import script from "./subjectiveMark.vue?vue&type=script&lang=js&"
export * from "./subjectiveMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f18aed",
  null
  
)

export default component.exports